import { useQuery } from '@tanstack/react-query';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { usePetitionGuidesPageData } from '#src/app/pages/petitionGuides/article/pageContext';
import { useSessionUuid } from '#src/app/shared/hooks/session';
import type { ShareLink } from '#src/app/shared/hooks/share';

import { getPetitionGuidesArticleShareLinks } from './api';

const QUERY_KEY = 'petition-guides-article-share-links';

type Result = {
	shareLinks: readonly ShareLink[];
	isLoading: boolean;
};

export function useShareLinksQuery(): Result {
	const {
		data: {
			article: { slug },
		},
	} = usePetitionGuidesPageData();

	const sessionUuid = useSessionUuid();
	const utilityContext = useUtilityContext();

	const { data, isLoading } = useQuery({
		queryKey: [QUERY_KEY, { slug, sessionUuid }],
		queryFn: async () => getPetitionGuidesArticleShareLinks({ slug }, utilityContext),
	});

	return {
		shareLinks: data ?? [],
		isLoading: isLoading && !data,
	};
}
